import React from 'react';
import {useIsFeatureActive} from '@aboutyou/feature-flags';
import {useCustomerIsVip, useFullSession} from '@aboutyou/user';
import {ContentPopperProps} from '@aboutyou/ui-components';
import {useIsHeaderBasCampaignActive} from '../../features/AboutYouLogo/hooks/useBasCampaign';

import {lazy} from '@aboutyou/lazy-imports';
import {NotificationCenterButtonShell} from './NotificationCenterButtonShell';

export const NotificationCenterRequest = lazy(() =>
  import('./NotificationCenterRequest.eager').then(mod => ({
    default: mod.NotificationCenterRequest,
  })),
);

export const NotificationCenter: React.FC<{
  NotificationCenterStreamComponent: ContentPopperProps['LayoutComponent'];
  headerContent?: React.ReactNode;
  topBodyContent?: React.ReactNode;
  notificationBellRef: React.RefObject<HTMLDivElement>;
}> = ({
  NotificationCenterStreamComponent,
  headerContent,
  topBodyContent,
  notificationBellRef,
}) => {
  const {isActive: isNotificationCenterEnabled} = useIsFeatureActive(
    'enable_notification_center',
  );
  const isCampaignHomeTakeoverActive = useIsHeaderBasCampaignActive();
  const isVipUser = useCustomerIsVip();
  const fullSession = useFullSession();

  /**
   * The home takeover header logo is not shown for VIP users, instead just the VIP logo is rendered,
   * which gives enough space to display the notifications icon, this is why validation
   * (isCampaignHomeTakeoverActive && !IsVipUser) is here
   */
  if (
    (isCampaignHomeTakeoverActive && !isVipUser) ||
    !isNotificationCenterEnabled
  ) {
    return null;
  }

  if (!fullSession) {
    return (
      <NotificationCenterButtonShell
        notificationBellRef={notificationBellRef}
      />
    );
  }

  return (
    <NotificationCenterRequest
      NotificationCenterStreamComponent={NotificationCenterStreamComponent}
      headerContent={headerContent}
      topBodyContent={topBodyContent}
      notificationBellRef={notificationBellRef}
    />
  );
};
